import { MetadataStore } from 'breeze-client';

import { BankAccount } from './bank-account';
import { BankAccountFeed } from './bank-account-feed';
import { DataProperty } from './data-property';
import { Job } from './job';
import { JobsDataProperties } from './jobs-data-properties';
import { Practice } from './practice';

export class PortalRegistrationHelper {

    static register(metadataStore: MetadataStore) {
        metadataStore.registerEntityTypeCtor('BankAccount', BankAccount);
        metadataStore.registerEntityTypeCtor('BankAccountFeed', BankAccountFeed);
        metadataStore.registerEntityTypeCtor('DataProperty', DataProperty);
        metadataStore.registerEntityTypeCtor('Job', Job);
        metadataStore.registerEntityTypeCtor('JobsDataProperties', JobsDataProperties);
        metadataStore.registerEntityTypeCtor('Practice', Practice);
    }
}
